module.exports = __webpack_public_path__ + "img/leonieandco-review-grid.d96131da.png";